import { User, UserManager } from 'oidc-client-ts';
import localStore from 'store2';
import posthog from 'posthog-js';

import { AUTHORITY, CLIENT_ID } from 'utils/setting';
import { authConfig } from 'config/authConfig';
import { pageRoutes } from 'config/router/pageRoutes';
import { store } from 'store/storeConfig';
import { fetchUser } from 'store/features/user/userSlice';

const userManager = new UserManager(authConfig);

userManager.events.addAccessTokenExpired(() => {
  userManager.signinSilent();
});

export const signinCallback = async () => {
  return await userManager
    .signinRedirectCallback()
    .then(async () => {
      localStore.remove(process.env.REACT_APP_LOCAL_STORAGE_CURRENT_USER);
      localStore.set("isFreshLogin", true);
      store.dispatch(fetchUser());

      window.location.replace(pageRoutes.home);
    })
    .catch((err) => console.log(err));
};

export const signinSilentCallback = () => {
  return userManager.signinSilentCallback();
};

export const login = () => {
  return userManager.signinRedirect();
};

export const logout = () => {
  posthog.reset(true); // Clears the identified user in PostHog
  localStore.remove(process.env.REACT_APP_LOCAL_STORAGE_CURRENT_USER);
  return userManager.signoutRedirect();
};

export const refreshToken = () => {
  return userManager.signinSilent();
};

export const isAuthenticated = () => {
  const oidcStorage = localStore.get(`oidc.user:${AUTHORITY}:${CLIENT_ID}`);
  const user: User = oidcStorage;

  return !!user && !!user.access_token;
};

export const getAuthToken = () => userManager.getUser().then((user) => user?.access_token);
